import React from 'react'
import { Link } from 'react-router-dom'
import * as CONFIG from './_config'
import ls from "local-storage";

class Page extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {

      var Name = "ORDER ONLINE NOW!";

    return (
        <div className="main-container full-width pt-5 mt-5">
            <div className="title-breadcrumb">
                <div className="container">
                    <div className="title-breadcrumb-inner">
                        <header className="entry-header">
                            <h1 className="entry-title">{Name}</h1>
                        </header>
                        <div className="breadcrumbs"><Link to="/">Home</Link><span className="separator">/</span><span>{Name}</span></div>
                    </div>
                </div>

            </div>

            <div className='container'>
                <div className="row">

                    <div className="vc_col-xs-12">
                        <div className="page-content default-page">

                            <article id="post-8436"
                                     className="post-8436 page type-page status-publish hentry">

                                <div className="entry-content">
                                    <div className="vc_row wpb_row vc_row-fluid">
                                        <div className="row-container" style={{/* marginLeft:'25%',*/ marginTop:'25px', textAlign: 'left', color:'#444'}} >
                                           <div className="wpb_column vc_column_container vc_col-sm-12">
                                              <div className="vc_column-inner">
                                                <div className="wpb_wrapper">
                                                  <div className="row" style={{ paddingTop:'10px'}} >
                                                    Shop with 2J’s Thriftway Online Powered by Rosie and have all the groceries you know and love from 2J’s Thriftway available for convenient store pickup! Each order is carefully hand-picked by our personal shoppers, and we offer a 100% happiness guarantee. Use your computer, tablet, or phone to shop from the comfort of your home or on the go, and pick them up at a convenient time of your choosing. Leave everything in the middle up to us!
                                                  </div>
                                                  <p style={{fontWeight:'bold', fontSize:'25px', textAlign:'left', paddingTop:'30px', marginLeft:'-15px'}}>HOW IT WORKS:</p>
                                                  <div className="row">
                                                    2J’s Thriftway Online is Powered by Rosie, our online shopping partner. To get started, select your store below to create a free account on Rosie, then start shopping our complete inventory for all your favorite items. At checkout, choose from available days, times, and store locations for convenient curbside pickup.
                                                  </div>
                                                  <p style={{fontWeight:'bold', fontSize:'17px', textAlign:'center', paddingTop:'30px'}}>YOU CAN ALSO DOWNLOAD OUR APP RIGHT TO YOUR IOS OR ANDROID DEVICE!</p>
                                                    <div style={{ textAlign:'center'}}>
                                                      <div>
                                                      {
                                                      <a href="https://play.google.com/store/apps/details?id=com.rosieapp.main&hl=en_US" target="_blank"  className="d-inline"
                                                         title="Download from Google Play"
                                                      >
                                                          <img
                                                              src="/assets/images/google-play-1.png"
                                                              alt="Download from google play"
                                                          />
                                                      </a>
                                                    }
                                                    {
                                                      <a href="https://itunes.apple.com/us/app/rosie/id798869911?mt=8" target="_blank" className="d-inline"
                                                         title="Download from App Store"
                                                      >
                                                          <img
                                                              src="/assets/images/appstore.png"
                                                              alt="Download from app store"
                                                          />
                                                      </a>
                                                    }
                                                    </div>
                                                    <p style={{fontWeight:'bold', fontSize:'20px', textAlign:'center', paddingTop:'30px'}}>Shop online now!</p>
                                                    <p style={{fontWeight:'bold', fontSize:'20px', textAlign:'center'}}>
                                                      <a className="btn btn-info btn-theme" style={{fontSize:'30px'}} target="_blank" href='http://rosieapp.com/shopstore/twojsthriftway'>START SHOPPING</a>
                                                    </p>
                                                  </div>
                                                  <div className="row">
                                                    <p style={{fontWeight:'bold', fontSize:'20px', textAlign:'left'}}>Quick Facts:</p>
                                                  </div>
                                                  <div className="row">
                                                  Curbside Pickup is free for a limited time! Choose whichever time between 10 AM and 7 PM, seven days a week, is most convenient for you to pick up your groceries.
                                                  </div>

                                                  <div className="row">
                                                  <p style={{fontWeight:'bold', fontSize:'20px', textAlign:'left', paddingTop:'15px'}}>FAQ:</p>
                                                  </div>

                                                  <div style={{fontWeight:'bold', fontSize:'15px', textAlign:'left', paddingTop:'15px'}}>How much does it cost?</div>
                                                  <div className="">
                                                  Limited Time Only – Free Pickup
                                                  </div>

                                                  <div style={{fontWeight:'bold', fontSize:'15px', textAlign:'left', paddingTop:'15px'}}>Do you offer delivery?</div>
                                                  <div className="">
                                                  2J’s Thriftway Online does not offer delivery at this time. Please watch for details about delivery in the future.
                                                  </div>

                                                  <div style={{fontWeight:'bold', fontSize:'15px', textAlign:'left', paddingTop:'15px'}}>What are 2J’s Thrifway hours?</div>
                                                  <div className="">
                                                  The 2J’s Thriftway Online grocery store is available to you 24/7 so you can shop and place your order whenever it is convenient for you. Our store pickup times are between 10 AM and 7 PM Monday – Saturday, 10 AM and 6 PM Sundays.
                                                  </div>
                                                </div>
                                              </div>
                                           </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
    }
}
export default Page;



